<template>
  <!-- This template will render all the services -->
  <div class="container">
      
      <h2 class="page-head">Our Services</h2>
      
      <div class="search-container">
        <input 
          type="text" 
          v-model="searchQuery" 
          placeholder="Search for a service (e.g., 'cut', 'color', 'mani')" 
          class="service-search-input"
          @input="filterServices">
        <button class="search-icon-btn" @click="filterServices" aria-label="Search Services">
          <span class="search-icon">🔍</span>
        </button>
      </div>

      <div class="services-grid">
        
        <div class="service-card" v-for="service in filteredServices" :key="service.id">
          
          <div class="service-image-container">
            <img :src="getImageUrl(service.image)" :alt="service.name" class="service-image">
          </div>
          
          <div class="service-content">
            <h3 class="service-name">{{ service.name }}</h3>
            <p class="service-description">{{ service.description }}</p>
            
            <div class="service-footer">
              <span class="service-price">${{ service.price }}</span>
              <button class="book-btn" @click="$emit('select-service', service)">
                Book Now
              </button>
            </div>
          </div>
        </div>

        <p v-if="filteredServices.length === 0" class="no-results">
          No services match your search query: "{{ searchQuery }}"
        </p>
        
      </div>
    </div>

</template>

<script>
// import the json file
import serviceData from '@/assets/services/services.json'
import axios from 'axios'
const API_BASE_URL = 'https://api-afrobraids.inchtechs.com/api/service/'

export default {
    name: 'AllServiceComponent',

    emits: ['select-service'],
    data() {
        return {
            searchQuery: '',
            //services: this.processServiceData(serviceData),
            services: [],
        }
    },
    async created(){
        this.services = await this.loadServices()
    },

    computed: {
        filteredServices() {
            // Converts query to lowercase for case-insensitive search
            const query = this.searchQuery.toLowerCase();
            
            if (!query) {
                return this.services;
            }

            return this.services.filter(service => 
                service.name.toLowerCase().includes(query) ||
                service.description.toLowerCase().includes(query)
            );
        }
    },
    methods: {
        filterServices() {
        },

        async loadServices() { // load services from the backend

            try {
                const response = await axios.get(`${API_BASE_URL}get_services`)
                return response.data
            } catch (error) {
                console.error("Error fetching data:", error);
                this.error = 'Failed to load products. Please try again later.';
                return []
            }
        },

        getImageUrl(filename) {
            console.log("The filename of the image in service is: ", filename)
            const API_BASE = 'https://api-afrobraids.inchtechs.com'; // Or your deployed URL
            
            const path_to_file = `${API_BASE}/uploads/services/${filename}`;
            console.log("Actual path to file: ", path_to_file)
            return path_to_file;
        },
    }
}
</script>

<style scoped>

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
    font-family: var(--font-sans);
}

.page-head {
    font-family: var(--font-serif);
    font-size: 2.5rem;
    color: var(--color-maroon);
    margin-top: 2rem;
    text-align: center;
    margin-bottom: 2rem;
    padding-bottom: 10px;
    /* Elegant Gold Underline */
    border-bottom: 3px solid var(--color-gold); 
}

/* --- Search/Filter Section --- */
.search-container {
    display: flex;
    width: 85%; 
    max-width: 600px;
    margin: 0 auto 3rem;
    border: 2px solid var(--color-maroon); /* Maroon border */
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.service-search-input {
    flex-grow: 1;
    padding: 10px 15px; 
    border: none;
    font-size: 1rem; 
    outline: none;
    color: var(--color-dark);
}

.service-search-input::placeholder {
    color: #999;
}

.search-icon-btn {
    background: var(--color-maroon); /* Maroon button */
    border: none;
    padding: 10px 18px; 
    cursor: pointer;
    transition: background-color 0.3s;
}

.search-icon-btn:hover {
    background-color: var(--color-earth); /* Earth tone on hover */
}

.search-icon {
    font-size: 1rem;
    color: white;
}

/* --- Service Cards Grid --- */
.services-grid {
    display: grid;
    grid-template-columns: 1fr; 
    gap: 30px; /* Increased gap for better separation */
    padding-bottom: 3rem;
}

/* Tablet Layout (2 columns) */
@media (min-width: 650px) {
    .services-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

/* Desktop Layout (3 columns) */
@media (min-width: 1000px) {
    .services-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

/* Individual Service Card*/
.service-card {
    border: 1px solid #f0f0f0;
    border-radius: 12px;
    overflow: hidden;
    /* More pronounced shadow for elegance */
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1); 
    display: flex;
    flex-direction: column;
    background-color: white;
    transition: box-shadow 0.3s, transform 0.2s;
}

.service-card:hover {
    box-shadow: 0 12px 25px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
}

.service-image-container {
    width: 100%; /* Changed to 100% to fill card width */
    padding-top: 60%; 
    position: relative;
    overflow: hidden;
    /* Add a subtle Gold separator below the image */
    border-bottom: 3px solid var(--color-gold); 
}

.service-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
}

.service-card:hover .service-image {
    transform: scale(1.05);
}

.service-content {
    padding: 20px 25px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.service-name {
    font-family: var(--font-serif);
    font-size: 1.5rem;
    color: var(--color-dark);
    margin-top: 0;
    margin-bottom: 8px;
}

.service-description{
    font-size: 0.95rem;
    color: #666;
    margin-bottom: 15px;
    flex-grow: 1;
}

/* Footer (Price and Button) */
.service-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;
    border-top: 1px solid #f0f0f0;
}

.service-price {
    font-size: 1.4rem;
    font-weight: bold;
    color: var(--color-earth); /* Price highlighted with Earth tone */
}

.book-btn {
    background-color: var(--color-maroon);
    color: white;
    text-decoration: none;
    padding: 10px 18px;
    border-radius: 20px; /* Pill shape for elegance */
    font-size: 0.9rem;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s, box-shadow 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.book-btn:hover {
    background-color: #4a0c19; /* Darker Maroon */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.no-results {
    grid-column: 1 / -1; 
    text-align: center;
    color: var(--color-maroon);
    padding: 40px;
    font-size: 1.2rem;
    font-style: italic;
    border: 2px dashed var(--color-gold);
    border-radius: 8px;
    background-color: #fffaf0; /* Light background for message */
}

</style>